import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Settings, Bell, CalendarDays, HelpCircle, Shield, LogOut } from 'lucide-react';
import { AuthContext } from '../App';
import { guardedMobileAction } from './MobileNavigation';

export default function MobileProfileMenu() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const items = [
    ['/account-settings', 'Account Settings', Settings],
    ['/notification-settings', 'Notification Settings', Bell],
    ['/my-history', 'Run History', CalendarDays], ['/support', 'Help', HelpCircle],
  ];
  if (user?.role === 'admin' || user?.role === 'scout') items.push(['/admin', 'Admin tools', Shield]);
  return <details className="mobile-profile-menu">
    <summary>Settings &amp; more</summary>
    <div>{items.map(([path, label, Icon]) => <button type="button" key={path} onClick={() => guardedMobileAction(() => navigate(path))}>
      <Icon size={19} aria-hidden="true" /><span>{label}</span><ChevronRight size={17} aria-hidden="true" />
    </button>)}
      <button type="button" onClick={() => guardedMobileAction(logout)}><LogOut size={19} aria-hidden="true" /><span>Sign Out</span><ChevronRight size={17} aria-hidden="true" /></button>
    </div>
  </details>;
}
